export const CUSTOMER_REPORT = {
  Summary: '/report/customers',
  ExportSummary: '/report/customers/export',
  Details: '/report/customers/details',
  ExportDetails: '/report/customers/export-details',
  BrithdayCustomers: '/report/customers/birthay-in-month',
  TotalCustomers: '/report/customers/total',
};
